// CONSTANTS
import { ROUTE_404 } from '@/constants/routes';
import * as roles from '@/constants/roles';
import { getNav } from '@/constants/menus';
import {
  adminMainRoute,
  csrAgentMainRoute,
  getPartnerAssetsRoute,
  partnerAdminMainRoute,
} from '@/constants/common';

export const getNavDataByRole = (currentRole, opts) => {
  let rootRoute;
  let mainNavigation = getNav(currentRole, opts);

  switch (currentRole) {
    case roles.ROLE_SERVICE_ADMIN:
      rootRoute = adminMainRoute;
      break;
    case roles.ROLE_PARTNER_ADMIN:
      rootRoute = partnerAdminMainRoute;
      break;
    case roles.ROLE_CSR_AGENT:
      rootRoute = csrAgentMainRoute;
      break;
    case roles.ROLE_CSR_VIEW_ONLY:
      rootRoute = getPartnerAssetsRoute(opts?.partner);
      break;
    default:
      mainNavigation = [];
      rootRoute = ROUTE_404;
  }

  return {
    rootRoute,
    mainNavigation,
  };
};

export function checkIsAdmin(user) {
  return user?.role?.[0] === roles.ROLE_SERVICE_ADMIN;
}

export default getNavDataByRole;
